import { render, staticRenderFns } from "./New.html?vue&type=template&id=785de884&scoped=true&"
import script from "./New.js?vue&type=script&lang=js&"
export * from "./New.js?vue&type=script&lang=js&"
import style0 from "./New.scss?vue&type=style&index=0&id=785de884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785de884",
  null
  
)

export default component.exports